// src/utils/services/AdvancedMD/advancedMdMatchAbility.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const ADVANCEDMD_MATCH_ABILITY_URL = `${API_BASE_URL}/api/advancedmd/match/ability`;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

/**
 * Realiza el match de paciente contra AdvancedMD usando nombre + DOB + sexo.
 * 
 * body esperado por el backend:
 * {
 *   firstName: string,
 *   lastName: string,
 *   dob: string (ISO-8601),
 *   sex: string
 * }
 * 
 * Devuelve lo que exponga tu backend (por ejemplo: { matches: [...], bestMatch: {...} } o una lista).
 */
export async function matchAdvancedMdPatientAbility(payload) {
  try {
    const res = await axios.post(ADVANCEDMD_MATCH_ABILITY_URL, payload, {
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return res.data;
  } catch (err) {
    console.error("Error matching AdvancedMD patient (ability):", err);
    throw err;
  }
}
